import React, {useEffect, useState} from "react";
import Actuator from "./pages/Actuator/Actuator";
import Layout from "./Components/layout/Layout";
import {Routes, Route, Navigate, BrowserRouter, useNavigate} from "react-router-dom";
import "./pages/Search/Search.module.css";
import "./App.module.css";
import CookieConsent from "react-cookie-consent";
import CssBaseline from "@mui/material/CssBaseline";

import "./Components/styles/CustomStyles1.css";


import {SearchView} from "./App/LandingSearchPage/SearchView";
import Zaplecze from "./Zaplecze/Zaplecze"
import {PartnersList} from "./Components/PartnersList/PartnersList";
import {ClientServices} from "./Components/ClientServices/ClientServices";
import {BeforeLogin} from "./Components/Login/BeforeLogin"

import MapOfGood from "./Components/MapOfGood/MapOfGood";

import Privacy from "./Components/Privacy/Privacy";
import GlobalStyles from "@mui/material/GlobalStyles";
import {useAuth0, Auth0Provider, withAuthenticationRequired} from "@auth0/auth0-react";

import {SupplierPage} from "./Components/SupplierCard/SupplierPage";

import {ErrorPage404} from "./Components/ErrorPage/ErrorPage404";
import NewSearchView from "./Components/SearchView/NewSearchView";
import {CompanyInfoCard} from "./Components/GoodDescriptionCard/CompanyInfoCard";
import {GoodDetailsBox} from "./Components/GoodDescriptionCard/GoodDetailsBox";
import {GoodDetailsCard} from "./Components/GoodDescriptionCard/GoodDetailsCard";

import {useAppInitialization} from "./Components/Hooks/useAppInitialization";


const ProtectedRoute = ({component, ...args}) => {
    const Component = withAuthenticationRequired(component, args);
    return <Component/>;
};

const Auth0ProviderWithRedirectCallback = ({children, ...props}) => {
    const navigate = useNavigate();
    const onRedirectCallback = (appState) => {
        navigate((appState && appState.returnTo) || window.location.pathname);
    };
    return (
        <Auth0Provider onRedirectCallback={onRedirectCallback} {...props}>
            {children}
        </Auth0Provider>
    );
};

const redirectURL = `${window.location.origin}/zaplecze`;

const ExternalRedirect = ({url}) => {
    useEffect(() => {

        window.location.href = url;
    }, []);

    return <div>Redirecting...</div>;
};

function App() {

    const {
        apikey,
        auth0ClientId,
        lat,
        lng,
        isReady,
        cityName
    } = useAppInitialization();


    const [sessionid, setsessionid] = useState(() => {
        return Date.now() + Math.random().toFixed(0);
    }, []);


    const {loginWithRedirect} = useAuth0();

    const LoginRedirect = () => {
        loginWithRedirect();
    };


    if (!auth0ClientId) return <div>Ładowanie...</div>;


    return (


        <BrowserRouter>

            <Auth0ProviderWithRedirectCallback
                domain="epid.eu.auth0.com"
                clientId={auth0ClientId}
                authorizationParams={{
                    redirect_uri: redirectURL,
                    scope: "openid lokalni epid profile msa",
                }}
                cacheLocation="localstorage"
            >

                <CssBaseline/>


                <GlobalStyles
                    styles={{
                        body: {
                            padding: 0,
                            margin: 0,
                            background: "linear-gradient(-45deg, #f29a26, #db2251, #ba1fa5, #2B46AF, #18a75c, #a9ce50)",
                            backgroundSize: "400% 400%",
                            animation: "gradient 15s ease infinite}",
                        }
                    }}
                />

                <Routes>
                    <Route path="/" element={<Layout city={cityName}/>}>
                        <Route index element={<SearchView sessionid={sessionid} apikey={apikey}/>}/>
                        <Route
                            path="/szukaj"
                            element={
                                <SearchView
                                    sessionid={sessionid}
                                    apikey={apikey}
                                />
                            }
                        />
                        <Route
                            path="/zaplecze/"
                            element={
                                <ProtectedRoute
                                    component={Zaplecze}
                                />
                            }
                        />
                        <Route
                            path="/uslugi/"
                            element={
                                <ClientServices/>
                            }
                        />
                        <Route
                            path="/logowanie/"
                            element={
                                <BeforeLogin/>
                            }
                        />
                        <Route
                            path="/login/"
                            element={
                                <LoginRedirect/>
                            }
                        />

                        <Route
                            path="/startowa/"
                            element={
                                <SearchView
                                    sessionid={sessionid}
                                    apikey={apikey}

                                />
                            }
                        />
                        <Route
                            path="/onas/"
                            element={
                                <PartnersList
                                    sessionid={sessionid}
                                    lat={lat}
                                    lon={lng}
                                    apikey={apikey}
                                    city={cityName}
                                />
                            }
                        />

                        <Route
                            path="/wyniki/:name/:id"
                            exact
                            element={
                                <NewSearchView
                                    sessionid={sessionid}
                                    lat={lat}
                                    lon={lng}
                                    apikey={apikey}
                                    city={cityName}
                                />
                            }
                        />
                        <Route
                            path="/wyniki/:name"
                            exact
                            element={
                                <NewSearchView
                                    sessionid={sessionid}
                                    lat={lat}
                                    lon={lng}
                                    apikey={apikey}
                                    city={cityName}
                                />
                            }
                        />

                        <Route
                            path="/mapadobra/"
                            element={
                                <MapOfGood
                                    sessionid={sessionid}
                                    mlat={lat}
                                    mlon={lng}
                                    apikey={apikey}
                                    city={cityName}
                                />
                            }
                        />
                        <Route
                            path="/partner/:seolink"
                            element={
                                <SupplierPage
                                    sessionid={sessionid}
                                    mlat={lat}
                                    mlon={lng}
                                    apikey={apikey}
                                    city={cityName}
                                />
                            }
                        />
                        <Route
                            path="/mapadobra/:name"
                            element={
                                <MapOfGood
                                    sessionid={sessionid}
                                    mlat={lat}
                                    mlon={lng}
                                    apikey={apikey}
                                    city={cityName}
                                />
                            }
                        />
                        <Route
                            path="/privacy"
                            element={
                                <Privacy
                                    sessionid={sessionid}
                                    mlat={lat}
                                    mlon={lng}
                                    apikey={apikey}
                                    city={cityName}
                                />
                            }
                        />
                        <Route
                            path="/test"
                            element={
                                <CompanyInfoCard/>
                            }
                        />
                        <Route
                            path="/test1"
                            element={
                                <GoodDetailsBox/>
                            }
                        />
                        <Route
                            path="/test2"
                            element={
                                <GoodDetailsCard/>
                            }
                        />
                        <Route
                            path="/mapadobra/:name/:id"
                            element={
                                <MapOfGood
                                    sessionid={sessionid}
                                    mlat={lat}
                                    mlon={lng}
                                    apikey={apikey}
                                    city={cityName}
                                />
                            }
                        />

                        <Route
                            path="/actuator"
                            exact
                            element={
                                <Actuator
                                    data="moj actuator"
                                />
                            }
                        />

                        <Route
                            path="/blad/404/"
                            exact
                            element={<ErrorPage404/>}
                        />

                        <Route
                            path="/startowa/*"
                            element={
                                <Navigate to="/"/>
                            }
                        />
                        <Route
                            path="/blog/"
                            element={
                                <ExternalRedirect
                                    url="http://lokalni.pl/blog/"/>
                            }
                        />
                        <Route
                            path="/kontakt/"
                            element={
                                <ExternalRedirect url="http://lokalni.pl/kontakt/"/>
                            }
                        />

                    </Route>

                </Routes>

                <CookieConsent
                    debug={false}
                    location="bottom"
                    buttonText="Rozumiem"
                    cookieName="consentCookie"
                    style={{
                        background: "white",
                        color: "black",
                        border: "1px solid #000",
                        borderRadius: "10px",
                        width: "90vw",
                        marginLeft: "5vw",
                        marginBottom: "2vw",
                        zIndex: "3000",
                    }}
                    buttonStyle={{
                        backgroundColor: "#2bfece",
                        fontSize: "13px",
                        borderRadius: "5px",
                    }}
                    expires={150}
                >
                    Ta strona korzysta z plików cookies.
                </CookieConsent>

            </Auth0ProviderWithRedirectCallback>
        </BrowserRouter>

    );
}

export default App;

// TODO Ikona czekania na Leadach tak jak na dobru
// TODO Do filtrów lidów i dobra dodać zwłokę czasową po której realizowane będzie filtrowanie ~2 sek od ostatniej zmiany
// TODO Czy leady też nie są filtrowane podczas przełączania epidów